import React, {useEffect} from 'react';
import {useSelector} from 'react-redux';
import {useNavigate, useLocation} from 'react-router-dom';
import AccessDenied from '../../pages/General/AccessDenied';
import RootState from '../../redux/states/root.state';
import useRoleCheck from '../../hooks/useRoleCheck';
import Spinner from '../common/Spinner';

interface ProtectedRouteProps {
    children: React.ReactNode;
    roles: string[];
}

const RoleRoute: React.FC<ProtectedRouteProps> = ({children,roles}) => {
    const {canAccess, checking} = useRoleCheck(roles);
    const {data:user, accessToken, loading, refreshing} = useSelector((state: RootState) => state.user);
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        if (!accessToken && !loading && !refreshing) {
            navigate('/login', { state: { from: location.pathname + location.search }, replace: true });
        }
    }, [accessToken, loading, refreshing, user, roles, navigate, location]);

    return (accessToken && canAccess) ? <>{children}</> : (loading || refreshing || !user || checking) ? <Spinner /> : <AccessDenied />

};

export default RoleRoute;